import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import VerbButton, { VERB_BUTTON_TYPE } from './VerbButton';
import LoadingIndicator from './LoadingIndicator';

class PaginatedFetch extends Component {
    static propTypes = {
        limit: PropTypes.number,
        fetchMoreFunc: PropTypes.func,
        currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        className: PropTypes.string,
        buttonClassName: PropTypes.string,
        buttonType: PropTypes.string,
        onlyLoadMoreOnce: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            loadOnce: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentPage !== prevProps.currentPage) {
            this.setState({
                isHidden: false // reset the button's visibility when currentPage changes
            });
        }
    }

    _onClickHandler = () => {
        const { limit, onlyLoadMoreOnce } = this.props;
        this.setState({
            isLoading: true
        });
        return this.props.fetchMoreFunc(limit).then((data) => {
            this.setState({
                isHidden: data < limit || onlyLoadMoreOnce,
                isLoading: false
            });
        });
    };

    render() {
        const {
            className,
            buttonClassName,
            buttonType = VERB_BUTTON_TYPE.SECONDARY_DEFAULT,
            onlyLoadMoreOnce
        } = this.props;
        return (
            <div className={cns('button-container', className)} style={{ display: 'flex', justifyContent: 'center' }}>
                {this.state.isLoading && (
                    <div className={'row'}>
                        <LoadingIndicator />
                    </div>
                )}
                {!this.state.isHidden && !this.state.isLoading && (
                    <VerbButton
                        className={buttonClassName || 'col-sm-2'}
                        buttonType={buttonType}
                        defaultMessage={onlyLoadMoreOnce ? 'LOAD ALL' : 'LOAD MORE'}
                        buttonText={onlyLoadMoreOnce ? 'LOAD ALL' : 'LOAD MORE'}
                        onClick={this._onClickHandler}
                    />
                )}
            </div>
        );
    }
}

export default PaginatedFetch;
